import { produce } from 'immer'
import { TourActionTypes, ITourState, TourActions } from './types'

const INITIAL_STATE: ITourState = {
  wizard: {
    step_1: false,
    step_2: false,
    step_3: false,
    step_4: false,
    dismissed: false,
  },
  dashboard: {
    seen: false,
    dismissed: false,
    restartCycleTourSeen: false,
    timerCardTourSeen: false,
    timerFullScreenTourSeen: false,
  },
}

const tourReducer = (state = INITIAL_STATE, action: TourActions): ITourState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case TourActionTypes.MARK_WIZARD_STEP_SEEN: {
        const stepKey = `step_${action.payload}` as keyof typeof draft.wizard
        if (stepKey in draft.wizard) {
          ;(draft.wizard[stepKey] as boolean) = true
        }
        break
      }

      case TourActionTypes.DISMISS_WIZARD_TOUR: {
        draft.wizard.dismissed = true
        break
      }

      case TourActionTypes.MARK_DASHBOARD_TOUR_SEEN: {
        draft.dashboard.seen = true
        break
      }

      case TourActionTypes.DISMISS_DASHBOARD_TOUR: {
        draft.dashboard.dismissed = true
        break
      }

      case TourActionTypes.MARK_RESTART_CYCLE_TOUR_SEEN: {
        draft.dashboard.restartCycleTourSeen = true
        break
      }

      case TourActionTypes.MARK_TIMER_CARD_TOUR_SEEN: {
        draft.dashboard.timerCardTourSeen = true
        break
      }

      case TourActionTypes.MARK_TIMER_FULLSCREEN_TOUR_SEEN: {
        draft.dashboard.timerFullScreenTourSeen = true
        break
      }

      default:
        return draft
    }
  })
}

export default tourReducer
